import { type FC } from 'react';
import { useSelector } from 'react-redux';
import { DiffMethod } from 'react-diff-viewer';
import { union } from 'lodash-es';

import { type ReorderConflict } from '@editor2/types/conflict';
import { type RootState } from '@editor2/reducers/root';
import ConflictDiffView from '../common/ConflictDiffView';
import { getChildName } from '../helpers';

interface Props {
	conflict: ReorderConflict;
	courseId: number;
}

const InitialMergedReorderView: FC<Props> = (props) => {
	const { conflict, courseId } = props;

	const courseState = useSelector((state: RootState) => state.courses[courseId]);

	const getInitNamesList = () => {
		const namesList = conflict.initial.map((id) => {
			const name = getChildName({ courseState, attribute: conflict.attribute, id });
			return name;
		});

		return namesList.join('\n');
	};

	const getMergedNamesList = () => {
		const merged = union(conflict.current, conflict.incoming);

		const namesList = merged.map((id) => {
			const name = getChildName({ courseState, attribute: conflict.attribute, id });
			return name;
		});

		return namesList.join('\n');
	};

	return (
		<ConflictDiffView
			oldValue={getInitNamesList()}
			newValue={getMergedNamesList()}
			compareMethod={DiffMethod.LINES}
		/>
	);
};

export default InitialMergedReorderView;
